import "./App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import About from "./AboutPage/js/About";
import Portfolio from "./PortfolioPage/js/Portfolio";
import Services from "./ServicesPage/js/Services";
import Industries from "./IndustriesPage/js/Industries";
import Contact from "./ContactPage/js/Contact";
import LandingPage from "./LandingPage/js/LandingPage";
import HeaderHome from "./HomePage/js/HeaderHome";
import Hero from "./HomePage/js/Hero";
import WritingBox from "./HomePage/js/WritingBox";
import Accordion from "./HomePage/js/Accordion";
import IconBox from "./HomePage/js/IconBox";
import StickyRequestQuote from "./RequestButton/js/StickyRequestQuote";
import HomeAboutUs from "./HomePage/js/HomeAboutUs";
import GoogleReviews from "./Reviews/js/GoogleReviews";
import FooterRequest from "./HomePage/js/FooterRequest";
import Footer from "./Footer/js/Footer";
import ScrollToTop from "./Animations/AnimationJS/ScrollToTop";

// The admin system (CRM, invoices, quotes, Ads dashboard, Safety forms) loads
// only when someone opens /admin. It used to ship in the single bundle every
// visitor downloads, so a person tapping a Google ad had to download the whole
// back office before the landing page could draw. Measured on mobile that put
// the main content at ~7 s, and Google Ads rated landing page experience BELOW
// AVERAGE on 8 of 13 keywords, which raises cost per click and lowers ad rank.
//
// Only the admin is split, deliberately. Several public stylesheets rely on
// bare element selectors that apply site-wide - HeaderHome.css styles every
// <header> and <nav>, including the landing page's own header - so splitting
// the public pages apart would change how they look whenever one is opened
// directly (which is how every ad visitor arrives). The admin's styles are all
// scoped to its own classes, so moving it out changes nothing anyone sees.
const Admin = lazy(() => import("./AdminPage/js/Admin"));

function App() {
  return (
    <Router>
      <div className="App">
      <ScrollToTop />
        <Switch>
          <Route path="/about" component={About} />
          <Route path="/portfolio" component={Portfolio} />
          <Route path="/services" component={Services} />
          <Route path="/industries" component={Industries} />
          <Route path="/contact" component={Contact} />
          <Route
            path="/admin"
            render={(props) => (
              <Suspense fallback={null}>
                <Admin {...props} />
              </Suspense>
            )}
          />
          <Route path="/lp/machine-moving" component={LandingPage} />
          <Route path="/lp/millwright" component={LandingPage} />
          <Route path="/lp/crane-rigging" component={LandingPage} />
          <Route path="/lp/plant-relocation" component={LandingPage} />
          <Route exact path="/">
          <HeaderHome />
            <StickyRequestQuote />
            <Hero />
            <WritingBox />
            <Accordion />
            <IconBox />
            <HomeAboutUs />
            <GoogleReviews />
            <FooterRequest />
            <Footer />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
